export const faqs = [
  {
    question: 'Does AVEGA sell tickets?',
    answer:
      'No. AVEGA connects to events that already exist. You get your ticket from the organizer as usual, and AVEGA adds actions and rewards on top.',
  },
  {
    question: 'Do I need an account?',
    answer:
      'Not to browse events. When you take part, we only ask for what’s really needed, for example so we can let you know if you win.',
  },
  {
    question: 'How are winners chosen?',
    answer:
      'Every draw follows selection rules fixed before the action starts. Draws are reproducible and recorded, and winners are informed in the app.',
  },
  {
    question: 'What do brands see?',
    answer:
      'Statistics from large enough groups, like how many people find a lighter phone important. Not individual profiles. Your contact details are only shared if you explicitly agree.',
  },
  {
    question: 'Do you track my location?',
    answer:
      'No continuous GPS tracking. Events are shown at city level, and check-ins happen by scanning an optional QR code at the venue.',
  },
  {
    question: 'Can I change my mind?',
    answer:
      'Yes. Withdraw any permission in your privacy center as easily as you gave it, and request access to or deletion of your data at any time.',
  },
];
